import driveUnitApi from '@/api/driveUnit.api'

export const driveUnitService = (function () {
  'use strict'

  /**
   * Crea una nueva unidad de manejo
   * @param {*} thing
   */
  async function create(zoneId, driveUnit) {
    try {
      const response = await driveUnitApi.create(zoneId, driveUnit)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  async function getDriveUnitByZoneId(zoneId) {
    try {
      const response = await driveUnitApi.getDriveUnitByZoneId(zoneId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }
  /**
   * Actualizar una UM
   */
  async function update(driveUnit, driveUnitId) {
    try {
      const response = await driveUnitApi.update(driveUnit, driveUnitId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Para eliminar una UM por zoneId
   */
  async function deleteOne(zoneId) {
    const response = await driveUnitApi.deleteOne(zoneId)
    return response.data
  }

  /**
   * Para eliminación múltiple por zoneIds
   */
  async function deleteMany(zoneIds) {
    const response = await driveUnitApi.deleteMany(zoneIds)
    return response.data
  }

  return {
    create,
    getDriveUnitByZoneId,
    update,
    deleteMany,
    deleteOne
  }
})()
